export const selectPassword = state => state.password;
